import React, { useEffect, useRef } from 'react';

const BackgroundMusic: React.FC = () => {
    const audioRef = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        // Tự động phát nhạc khi component mount
        if (audioRef.current) {
            audioRef.current.volume = 0.3; // Âm lượng 30%
            audioRef.current.play().catch(error => {
                // Trình duyệt có thể chặn autoplay, bỏ qua lỗi
                console.log('Autoplay bị chặn:', error);
            });
        }
    }, []);

    return (
        <audio
            ref={audioRef}
            loop
            preload="auto"
            style={{ display: 'none' }}
        >
            <source src="/music/background-music.mp3" type="audio/mpeg" />
            <source src="/music/background-music.ogg" type="audio/ogg" />
        </audio>
    );
};

export default BackgroundMusic; 